import { React, useState, useEffect, useCallback } from 'react';
import Layout from '../../components/layout/Layout';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, } from 'chart.js';
import { getData, postFileData, imageUrl } from '../../services/apiService'
import { Box, Button, Typography, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useDropzone } from 'react-dropzone';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const InstructorProfile = () => {
    const [data, setData] = useState();
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        getInstructorProfile();
    }, [])

    const getInstructorProfile = async () => {
        try {
            const response = await getData('get-instructor-profile');

            if (response) {
                setData(response.data)
            }

        } catch (error) {
            console.error('Failed to fetch data', error);
        }
    }

    const coursesData = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Course',
                data: [4, 8, 6, 5, 10, 7, 8, 12, 6, 9, 11, 14],
                borderColor: 'rgba(106, 106, 201, 1)',
                backgroundColor: 'rgba(106, 106, 201, 0.6)',
                borderWidth: 2,
                borderRadius: 8,
            },
        ],
    };

    const coursesOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 20,
                ticks: {
                    stepSize: 2,
                },
            },
        },
    };

    const studentsData = {
        labels: ['Enrolled', 'In Progress', 'Completed'],
        datasets: [
            {
                data: [70, 20, 10], // 70% completed, 20% enrolled, 10% dropped
                backgroundColor: [
                    '#7978E9',
                    '#4B49AC',
                    '#98BDFF',
                ],
                borderColor: [
                    '#7978E9',
                    '#4B49AC',
                    '#98BDFF',
                ],
                borderWidth: 2,
                cutout: '70%',
            },
        ],
    };
    const studentsOptions = {
        cutout: '70%',
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return `${context.label}: ${context.parsed}%`;
                    },
                },
            },
        },
    };

    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
            setSelectedFile(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/*': ['.jpeg', '.jpg', '.png', '.gif']
        },
        maxFiles: 1
    });

    const handleImageUpload = async () => {
        if (!selectedFile) return;

        try {
            const formData = new FormData();
            formData.append('profileImage', selectedFile);

            const response = await postFileData('/update-profile-image', formData);
            if (response) {
                setData(prev => ({ ...prev, profileImage: response?.profile?.profileImage }));
                setShowImageModal(false);
                setSelectedFile(null);
                setPreviewUrl(null);
            }
        } catch (error) {
            console.error('Failed to upload image', error);
        }
    };

    return (
        <Layout>
            <div className="p-4 sm:p-6 lg:p-8 xl:p-10 bg-gray-100 min-h-screen w-full">
                <div className="max-w-none xl:max-w-8xl 2xl:max-w-9xl mx-auto">
                    <div class="w-[1116px] h-[860px]">
                        <div class="h-[860px]">
                            <div className="relative w-[1527px] h-[860px] bg-[#ffffff] rounded-[10px] overflow-hidden">
                                <div
                                    className="absolute top-1 left-9 font-heading font-[number:var(--heading-font-weight)] text-black text-[length:var(--heading-font-size)] tracking-[var(--heading-letter-spacing)] leading-[var(--heading-line-height)] [font-style:var(--heading-font-style)]"
                                >
                                    View Profile
                                </div>
                                <div className="absolute w-[950px] h-[300px] top-[54px] left-[537px]">
                                    <div
                                        className="relative w-[948px] h-[300px] bg-white rounded-[10px] border border-solid border-[#e6e6e6] shadow-[1px_1px_10px_#00000014]"
                                    >
                                        <div
                                            className="flex flex-col w-[425px] h-[88px] items-start gap-2.5 px-[18px] py-[21px] absolute top-[53px] left-6 bg-[#fbfafc] rounded-[5px] border-[1.4px] border-solid border-[#f8f2ff]"
                                        >
                                            <div className="relative w-[90px] h-[43px]">
                                                <img
                                                    className="absolute w-[18px] h-5 top-[11px] left-0"
                                                    src="https://c.animaapp.com/mc2wb6ozProVWA/img/vector.svg"
                                                    alt="Courses icon"
                                                />
                                                <div className="absolute w-[66px] h-[43px] top-0 left-7">
                                                    <div
                                                        className="absolute top-[25px] left-0 [font-family:'Poppins',Helvetica] font-normal text-dark-text text-xs tracking-[0] leading-[normal]"
                                                    >
                                                        8 course
                                                    </div>
                                                    <div
                                                        className="top-0 left-0 font-[number:var(--medium-text-font-weight)] text-[length:var(--medium-text-font-size)] absolute font-medium-text text-black tracking-[var(--medium-text-letter-spacing)] leading-[var(--medium-text-line-height)] [font-style:var(--medium-text-font-style)]"
                                                    >
                                                        Courses
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="flex flex-col w-[425px] h-[88px] items-start gap-2.5 px-2.5 py-[21px] absolute top-[53px] left-[475px] bg-[#fbfafc] rounded-[5px] border-[1.4px] border-solid border-[#f8f2ff]"
                                        >
                                            <div className="inline-flex items-center justify-center gap-2.5 relative flex-[0_0_auto]">
                                                <img
                                                    className="relative w-[21px] h-[21px]"
                                                    src="https://c.animaapp.com/mc2wb6ozProVWA/img/vector-2.svg"
                                                    alt="Students icon"
                                                />
                                                <div className="relative w-[108px] h-[43px]">
                                                    <div className="relative w-28 h-[43px]">
                                                        <div
                                                            className="absolute top-0 left-0 font-medium-text font-[number:var(--medium-text-font-weight)] text-black text-[length:var(--medium-text-font-size)] tracking-[var(--medium-text-letter-spacing)] leading-[var(--medium-text-line-height)] [font-style:var(--medium-text-font-style)]"
                                                        >
                                                            Total Students
                                                        </div>
                                                        <div
                                                            className="absolute top-[25px] left-0 [font-family:'Poppins',Helvetica] font-normal text-dark-text text-xs tracking-[0] leading-[normal]"
                                                        >
                                                            100+ students
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="flex flex-col w-[425px] h-[88px] items-start gap-2.5 px-[18px] py-[21px] absolute top-[162px] left-6 bg-[#fbfafc] rounded-[5px] border-[1.4px] border-solid border-[#f8f2ff]"
                                        >
                                            <div className="inline-flex items-center justify-center gap-2.5 relative flex-[0_0_auto]">
                                                <img
                                                    className="relative w-4 h-[21.62px]"
                                                    src="https://c.animaapp.com/mc2wb6ozProVWA/img/vector-4.svg"
                                                    alt="Awards icon"
                                                />
                                                <div className="relative w-[61px] h-[43px] mr-[-4.00px]">
                                                    <div
                                                        className="absolute top-[25px] left-0 [font-family:'Poppins',Helvetica] font-normal text-dark-text text-xs tracking-[0] leading-[normal]"
                                                    >
                                                        8 Awards
                                                    </div>
                                                    <div
                                                        className="absolute top-0 left-0 font-medium-text font-[number:var(--medium-text-font-weight)] text-black text-[length:var(--medium-text-font-size)] tracking-[var(--medium-text-letter-spacing)] leading-[var(--medium-text-line-height)] [font-style:var(--medium-text-font-style)]"
                                                    >
                                                        Awards
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="flex w-[425px] h-[88px] items-start gap-2.5 px-[11px] py-[21px] absolute top-[162px] left-[475px] bg-[#fbfafc] rounded-[5px] border-[1.4px] border-solid border-[#f8f2ff]"
                                        >
                                            <div className="inline-flex items-center justify-center gap-2.5 relative flex-[0_0_auto]">
                                                <img className="relative w-6" src="https://c.animaapp.com/mc2wb6ozProVWA/img/star-s-fill.svg" alt="Rating icon" />
                                                <div className="relative w-[53px] h-[43px] mr-[-4.00px]">
                                                    <div
                                                        className="absolute top-0 left-0 font-medium-text font-[number:var(--medium-text-font-weight)] text-dark text-[length:var(--medium-text-font-size)] tracking-[var(--medium-text-letter-spacing)] leading-[var(--medium-text-line-height)] [font-style:var(--medium-text-font-style)]"
                                                    >
                                                        Rating
                                                    </div>
                                                    <div
                                                        className="absolute top-[25px] left-0 [font-family:'Poppins',Helvetica] font-normal text-dark-text text-xs tracking-[0] leading-[normal]"
                                                    >
                                                        4.5
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="absolute top-[15px] left-[25px] font-primary font-[number:var(--primary-font-weight)] text-black text-[length:var(--primary-font-size)] tracking-[var(--primary-letter-spacing)] leading-[var(--primary-line-height)] [font-style:var(--primary-font-style)]"
                                        >
                                            Overview
                                        </div>
                                    </div>
                                </div>
                                <div className="absolute w-[460px] h-[522px] top-[298px] left-[38px]">
                                    <div className="w-[462px] h-[522px]">
                                        <div
                                            className="relative h-[524px] -top-px -left-px bg-white rounded-[10px] border border-solid border-[#e6e6e6] shadow-[1px_1px_10px_#00000014]"
                                        >
                                            <div
                                                className="absolute top-4 left-[18px] font-primary font-[number:var(--primary-font-weight)] text-black text-[length:var(--primary-font-size)] tracking-[var(--primary-letter-spacing)] leading-[var(--primary-line-height)] [font-style:var(--primary-font-style)]"
                                            >
                                                Students
                                            </div>
                                            <div className="absolute w-[162px] h-40 top-[72px] left-[100px] flex items-center justify-center">
                                                <div className="relative w-40 h-40 flex items-center justify-center">
                                                    <Doughnut data={studentsData} options={studentsOptions} width={160} height={160} />
                                                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 font-semibold text-black text-xl">
                                                        70%
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="absolute w-[160px] h-[95px] top-64 left-[124px]">
                                                <div className="space-y-3 lg:space-y-4">
                                                    <div className="flex items-center gap-2 lg:gap-3">
                                                        <div className="w-3 h-3 lg:w-4 lg:h-4 rounded" style={{ backgroundColor: '#7978E9' }}></div>
                                                        <span className="text-sm lg:text-base font-medium">Enrolled</span>
                                                    </div>
                                                    <div className="flex items-center gap-2 lg:gap-3">
                                                        <div className="w-3 h-3 lg:w-4 lg:h-4 rounded" style={{ backgroundColor: '#4B49AC' }}></div>
                                                        <span className="text-sm lg:text-base font-medium">In Progress</span>
                                                    </div>
                                                    <div className="flex items-center gap-2 lg:gap-3">
                                                        <div className="w-3 h-3 lg:w-4 lg:h-4 rounded" style={{ backgroundColor: '#98BDFF' }}></div>
                                                        <span className="text-sm lg:text-base font-medium">Completed</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="absolute w-[950px] h-[438px] top-[374px] left-[537px]">
                                    <div className="w-[950px] h-[438px]">
                                        <div
                                            className="relative h-[440px] -top-px -left-px bg-white rounded-[10px] border border-solid border-[#e6e6e6] shadow-[1px_1px_10px_#00000014]"
                                        >
                                            <div
                                                className="top-2.5 left-6 font-[number:var(--primary-font-weight)] text-[length:var(--primary-font-size)] text-center absolute font-primary text-black tracking-[var(--primary-letter-spacing)] leading-[var(--primary-line-height)] [font-style:var(--primary-font-style)]"
                                            >
                                                Courses
                                            </div>
                                            <div className="absolute w-[880px] h-[340px] top-[64px] left-[25px] flex items-center justify-center">
                                                <Bar data={coursesData} options={coursesOptions} height={291} width={607} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="absolute w-[466px] h-[215px] top-[54px] left-[38px]">
                                    <div
                                        className="relative w-[462px] h-[217px] -top-px -left-px bg-white rounded-[10px] border border-solid border-[#e6e6e6] shadow-[1px_1px_10px_#00000014]"
                                    >
                                        <div className="absolute w-[460px] h-[107px] top-px left-px">
                                            <div className="absolute w-[460px] h-[107px] top-0 left-0">
                                                <div
                                                    className="absolute w-[460px] h-20 top-0 left-0 rounded-[10px_10px_0px_0px] [background:linear-gradient(90deg,rgba(181,205,249,1)_30%,rgba(10,68,175,0.6)_100%)]"
                                                ></div>
                                                <div className="absolute w-20 h-20 top-[27px] left-3.5">
                                                    <img
                                                        src={`${imageUrl}${data?.profileImage}`}
                                                        className="w-[80px] h-[80px] rounded-full object-cover border-2 border-white shadow-md"
                                                        alt="Profile"
                                                    />
                                                    <div
                                                        className="absolute w-[24px] h-[24px] bottom-1 right-1 bg-[#000000aa] rounded-full shadow-[0px_0px_10px_#0000001a] flex items-center justify-center cursor-pointer hover:bg-[#000000cc] transition-colors"
                                                        onClick={() => setShowImageModal(true)}>
                                                        <img
                                                            className="w-3 h-3"
                                                            src="https://c.animaapp.com/mc2wb6ozProVWA/img/vector-3.svg"
                                                            alt="Edit icon"
                                                        />
                                                    </div>
                                                    {/* </div> */}
                                                </div>
                                                <div className="absolute w-16 h-7 top-[9px] left-[375px] bg-white rounded-[3px]">
                                                    <div className="relative w-[50px] h-[21px] top-[3px] left-2">
                                                        <img
                                                            className="absolute w-3.5 h-3.5 top-0.5 left-0"
                                                            src="https://c.animaapp.com/mc2wb6ozProVWA/img/vector-1.svg"
                                                            alt="Edit icon"
                                                        />
                                                        <div
                                                            className="absolute w-[27px] top-0 left-[21px] font-paratext font-[number:var(--paratext-font-weight)] text-dark-text text-[length:var(--paratext-font-size)] tracking-[var(--paratext-letter-spacing)] leading-[var(--paratext-line-height)] [font-style:var(--paratext-font-style)]"
                                                        >
                                                            Edit
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="absolute w-[72px] h-[17px] top-[81px] left-[362px]">
                                                <div
                                                    className="absolute top-0 left-4 font-small-text font-[number:var(--small-text-font-weight)] text-[#31a142] text-[length:var(--small-text-font-size)] tracking-[var(--small-text-letter-spacing)] leading-[var(--small-text-line-height)] [font-style:var(--small-text-font-style)]"
                                                >
                                                    {data?.role_id?.role_name}
                                                </div>
                                                <div className="absolute w-1.5 h-1.5 top-[5px] left-0 bg-[#31a042] rounded-[3px]"></div>
                                            </div>
                                        </div>
                                        <p
                                            className="absolute top-[123px] left-3.5 font-paratext font-[number:var(--paratext-font-weight)] text-dark-text text-[length:var(--paratext-font-size)] tracking-[var(--paratext-letter-spacing)] leading-[var(--paratext-line-height)] [font-style:var(--paratext-font-style)]"
                                        >
                                            Name : {data?.firstName} {data?.lastName}
                                        </p>
                                        <div
                                            className="absolute top-[148px] left-3.5 font-paratext font-[number:var(--paratext-font-weight)] text-dark-text text-[length:var(--paratext-font-size)] tracking-[var(--paratext-letter-spacing)] leading-[var(--paratext-line-height)] [font-style:var(--paratext-font-style)]"
                                        >
                                            Email :&nbsp;&nbsp;{data?.email}
                                        </div>
                                        <p
                                            className="absolute top-[173px] left-3.5 font-paratext font-[number:var(--paratext-font-weight)] text-dark-text text-[length:var(--paratext-font-size)] tracking-[var(--paratext-letter-spacing)] leading-[var(--paratext-line-height)] [font-style:var(--paratext-font-style)]"
                                        >
                                            Contact No : +91 {data?.phone}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Image Upload Modal */}
            <Modal
                open={showImageModal}
                onClose={() => {
                    setShowImageModal(false); setSelectedFile(null); setPreviewUrl(null);
                }}
                aria-labelledby="image-upload-modal"
            >
                <Box sx={{
                    position: 'absolute', top: '50%', left: '50%', width: 400,
                    bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2,
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h2">
                            Update Profile Image
                        </Typography>
                        <IconButton
                            onClick={() => { setShowImageModal(false); setSelectedFile(null); setPreviewUrl(null); }}
                            sx={{ position: 'absolute', right: 8, top: 8, color: 'gray' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box
                        {...getRootProps()}
                        sx={{
                            border: '2px dashed', borderColor: isDragActive ? 'primary.main' : 'grey.300',
                            borderRadius: 1, p: 3, textAlign: 'center', cursor: 'pointer',
                            mb: 2, bgcolor: isDragActive ? 'action.hover' : 'background.paper',
                        }}
                    >
                        <input {...getInputProps()} />
                        <CloudUploadIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                        <Typography>
                            {isDragActive ? "Drop the image here" : "Drag and drop an image here, or click to select"}
                        </Typography>
                    </Box>

                    {previewUrl && (
                        <Box sx={{ mb: 2, textAlign: 'center' }}>
                            <img src={previewUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '4px', }} />
                        </Box>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button variant="outlined" onClick={() => { setShowImageModal(false); setSelectedFile(null); setPreviewUrl(null); }} > Cancel </Button>
                        <Button variant="contained" onClick={handleImageUpload} disabled={!selectedFile} > Upload </Button>
                    </Box>
                </Box>
            </Modal>
        </Layout >
    );
};

export default InstructorProfile;